/**
 * Imperative half of the marketing → app boundary.
 *
 * Separate from `components/navigation/AppEntryLink` so that file
 * exports only a component (fast-refresh boundary). The reasoning for
 * why this is a document load rather than a route change lives there.
 *
 * `assign` rather than `location.href =` so a test can observe the call.
 */
export function enterApp(to: string): void {
  window.location.assign(to);
}
